<app-page-container>
  <div class="opcoes">
    <app-header appTitle="Histórico de pedidos">
      <div class="sub-titulo" *ngIf="autorizacoes.listarEquipamentos;">
      </div>
      <div class="tab-navegacao">
        <button routerLink="/suprimentos/historico-de-pedidos">Em andamento</button>
        <button class="button__styles" class="ml-4">Entregues</button>
      </div>
      <form [formGroup]="filtraForm" class="filtro">
        <h5>Filtrar</h5>
        <div class="filtro__content">
          <div class="filtro__pesquisar">
            <input class="input__pesquisar" formControlName="FiltroPesquisar" placeholder="Pesquisar..." type="search">
            <button class="btn__pesquisar" (click)="getPedidosSuprimentos(true)">Buscar</button>
          </div>
          <app-filtro-generico [filterInputs]="[
          { label: 'Número de Série', formControlName: 'NumSerie' },
          { label: 'Patrimônio', formControlName: 'NumPatrimonio' }
        ]" (OnClickApplyButton)="getPedidosSuprimentos(true)"
            (filterData)="receiveFilterData($event)"></app-filtro-generico>
        </div>
      </form>
    </app-header>
    <app-tabela [cabecalhos]="['Cód. Pedido', 'Data de abertura', 'Cliente', 'Site', 'Aberto por', 'Status', 'Ações']"
      [items]="suprimentos.registros" [colunasOcultas]="['Ações']"
      [condicoesColunas]="[{ columnName: 'Ações', condition: autorizacoes.exibirDetalhesPedido }]">
      <ng-container *ngFor="let suprimento of suprimentos.registros">
      <ng-container *ngIf="suprimento.status === 'PEDIDO ENTREGUE'">
      <tr>
        <td>{{suprimento.codPedido}}</td>
        <td> {{suprimento.dataAbertura | date: 'dd/MM/yyyy' }}</td>
        <div *ngIf="environment.company === 'apnetworks'; then apnetworksCliente else kmDoBrasilCliente"></div>
        <ng-template #apnetworksCliente>
          <td> {{suprimento.nomeCliente || suprimento.nomeFantasia || "Sem dados"}} </td>
        </ng-template>
        <ng-template #kmDoBrasilCliente>
          <td> {{suprimento.nomeFantasia || suprimento.nomeCliente || "Sem dados"}} </td>
        </ng-template>
        <td> {{suprimento.site}} </td>
        <td> {{suprimento.abertoPor || 'N/A'}} </td>
        <td> {{suprimento.status}} </td>
        <td *ngIf="autorizacoes.exibirDetalhesPedido">
          <button class="visualizar-btn"
            routerLink="/suprimentos/historico-de-pedidos/{{ suprimento.codPedido }}">Visualizar</button>
        </td>
      </tr>
    </ng-container>
  </ng-container>
    </app-tabela>
  </div>
  <app-paginacao nomeDaLista="Suprimentos" [(dados)]="suprimentos" (dadosChange)="getPedidosSuprimentos()"
    *ngIf="this.suprimentos.registros.length !== 0"></app-paginacao>
</app-page-container>